import React from 'react';

import Popover from "../Popover";
import { Button as ButtonAnt, Popconfirm, PopoverProps } from "antd";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  MenuOutlined,
  MoreOutlined,
  PlusOutlined,
  EyeOutlined,
  EyeInvisibleOutlined
} from "@ant-design/icons";
import './style.scss';

interface OptionsButtonInterface {
  options?: any;
  placement?: PopoverProps['placement'];
  horizontal?: boolean;
}

interface ButtonInterface {
  onClick: Function;
  title?: string | null;
  icon?: React.FC | null;
  className?: string | null;
}

interface ButtonToggleShowInterface {
  onClick: Function;
  state: boolean;
}

export const Button = ({ onClick, title, icon, className }: ButtonInterface) => (
  <button className={`v-link2 ${className}`} onClick={() => onClick()} type='button'>
    {icon && React.createElement(icon)} {title}
  </button>
);

export const OptionsButton = ({ options, horizontal, placement = 'rightTop' }: OptionsButtonInterface) => {
  const content = options.map((option: Element) => option);
  const className = `v-settings-options ${horizontal ? 'o-horizontal' : ''}`

  return (
    <Popover trigger='hover' placement={placement} content={content} overlayClassName={className}>
      <ButtonAnt type="text" className='o-btn-settings' icon={<MoreOutlined />} />
    </Popover>
  )
}

export const ButtonReorder = ({ onClick, title = 'Reorder', icon = MenuOutlined }: ButtonInterface) => (
  <Button onClick={onClick} title={title} icon={icon} />
)

export const ButtonToggleShow = ({ onClick, state }: ButtonToggleShowInterface) => {
  if (state) {
    return <Button onClick={onClick} title='Hide' icon={EyeInvisibleOutlined} />
  } else {
    return <Button onClick={onClick} title='Show' icon={EyeOutlined} />
  }
}

export const ButtonCreate = ({ onClick, title = 'Create', icon = PlusOutlined }: ButtonInterface) => (
  <Button onClick={onClick} title={title} icon={icon} />
)

export const ButtonEdit = ({ onClick, title = 'Edit', icon = EditOutlined }: ButtonInterface) => (
  <Button onClick={onClick} title={title} icon={icon} />
)

export const ButtonDestroy = ({ onClick, title = 'Destroy', icon = DeleteOutlined }: ButtonInterface) => (
  <Popconfirm
    placement="bottomRight"
    title='Are you sure to delete this item?'
    onConfirm={() => onClick()}
    okText="Yes"
    cancelText="No"
  >
    <Button onClick={() => {}} title={title} icon={icon} />
  </Popconfirm>
)

interface ButtonDownloadInterface {
  href: string;
  title?: string;
  filename?: string;
  className?: string;
}

export const ButtonDownload = ({ href, title = 'Download', filename, className }: ButtonDownloadInterface) => (
  <a
    href={href}
    download={filename || href.split('/').pop() || 'download'}
    className={`v-link2 ${className || ''}`}
  >
    <DownloadOutlined /> {title}
  </a>
)
